module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageSummer/DIGITAL_CAMOUFLAGE_SUMMER_usa.937ea5f1.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageSummer/DIGITAL_CAMOUFLAGE_SUMMER_usa.png
// module id = 1237
// module chunks = 16